import styled from 'styled-components'

export const FormError = styled.span`
  color: ${({ theme }) => theme.colors.state.negative.A};
  font-size: 0.875rem;
`
